import { Skeleton } from '@skin-seoul/design-system';
import type { Currency } from '@skin-seoul/service';

export function CartBenefitsBannerSkeleton({ currency, empty = false }: { currency?: Currency; empty?: boolean }) {
  const height = (() => {
    if (empty) {
      return 'h-[88px]';
    }
    if (currency === 'COP') {
      return 'h-[105px]';
    }
    return 'h-[89px]';
  })();
  return (
    <div aria-hidden="true" className={`flex w-full flex-col gap-2 rounded-2xl bg-neutral-50 px-3 pt-3 ${height}`}>
      <Skeleton className="h-4 w-3/4 motion-reduce:animate-none" />
      <Skeleton className="mt-1 h-1.5 w-full rounded-full motion-reduce:animate-none" />
      <div className="flex justify-between gap-3">
        {[0, 1, 2].map((key) => (
          <div key={key} className="flex w-1/4 flex-col gap-1">
            <Skeleton className="h-3 w-full motion-reduce:animate-none" />
            {currency === 'COP' && !empty && <Skeleton className="h-3 w-3/4 motion-reduce:animate-none" />}
          </div>
        ))}
      </div>
    </div>
  );
}
